import { render, staticRenderFns } from "./adkar-page.vue?vue&type=template&id=585c82e1&scoped=true&"
import script from "./adkar-page.vue?vue&type=script&lang=js&"
export * from "./adkar-page.vue?vue&type=script&lang=js&"
import style0 from "./adkar-page.vue?vue&type=style&index=0&id=585c82e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c82e1",
  null
  
)

export default component.exports